import * as React from 'react';
import PulsoidClient from '../PulsoidClient';
import {PROD_HOST_NAME} from '../utils/locationUtils';
import {ActionHref, Help} from '../system/buttons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faStar} from '@fortawesome/free-solid-svg-icons';
import {SaleComponent} from '../system/sale';
import {SaleButtonClassName} from '../system/sale';
import {LoaderWrapper} from '../system/Loader/Loader';
import {PremiumWrapperFeatureDescription} from '../system/FeatureDescriptionModal';

export class PremiumWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.client = new PulsoidClient();
    this.state = {};
  }

  componentDidMount() {
    this.client.getPremiumInfo().then((premiumInfo) => {
      this.setState({premiumInfo}, () => {
        if (this.props.onPremiumChange) {
          this.props.onPremiumChange(premiumInfo.isPremium);
        }
      });
    });
  }

  handleActivateTrial = () => {
    this.setState({status: 'ActivatingTrial'}, () =>
      this.client
        .activateTrial()
        .then((_) => this.client.getPremiumInfo())
        .catch((_) => this.setState({status: 'ErrorActivatingTrial'}))
        .then((premiumInfo) =>
          this.setState({premiumInfo, status: undefined}, () => {
            if (this.props.onPremiumChange) {
              this.props.onPremiumChange(premiumInfo.isPremium);
            }
          })
        )
    );
  };

  render() {
    let foo;
    let style = {
      border: '1px solid #222',
      padding: 20,
      margin: 5,
      borderRadius: 5,
      textAlign: 'center',
      color: 'black',
      backgroundColor: 'white',
    };
    let broPlanIsRequiredText = this.props.broPlanIsRequiredText
      ? this.props.broPlanIsRequiredText
      : 'BRO plan is required for this feature';
    let pricingLink = PROD_HOST_NAME + '/pricing';
    if (this.props.bi) {
      pricingLink = pricingLink + `?bi.from=${this.props.bi.from}`;
      if (this.props.bi.id) {
        pricingLink += `&bi.id=${this.props.bi.id}`;
      }
    }

    if (this.state.status) {
      if (this.state.status === 'ActivatingTrial') {
        foo = (
          <LoaderWrapper loading={true} description={'Activating trial...'} />
        );
      } else if (this.state.status === 'ErrorActivatingTrial') {
        foo = <h2>Error while activating trial</h2>;
      }
    } else {
      if (this.state.premiumInfo) {
        if (this.state.premiumInfo.isPremium) {
          return this.props.children;
        } else {
          if (this.state.premiumInfo.isHadTrial) {
            foo = (
              <div style={style}>
                <h5>
                  {broPlanIsRequiredText} <PremiumWrapperFeatureDescription />
                </h5>
                <div className={'d-flex justify-content-center'}>
                  <ActionHref
                    href={pricingLink}
                    className={SaleButtonClassName}
                  >
                    <FontAwesomeIcon icon={faStar} /> &nbsp;Upgrade to BRO Plan{' '}
                    <SaleComponent />
                  </ActionHref>
                </div>
              </div>
            );
          } else {
            foo = (
              <div style={style}>
                <h5>
                  {broPlanIsRequiredText} <PremiumWrapperFeatureDescription />
                </h5>
                <div className={'d-flex justify-content-center'}>
                  <ActionHref
                    href={pricingLink}
                    className={SaleButtonClassName}
                  >
                    <FontAwesomeIcon icon={faStar} /> &nbsp;Upgrade to BRO Plan{' '}
                    <SaleComponent />
                  </ActionHref>
                  <span style={{margin: '10px'}}> or </span>
                  <Help onClick={this.handleActivateTrial}>Activate trial</Help>
                </div>
              </div>
            );
          }
        }
      } else {
        foo = <LoaderWrapper loading={true} description={'Loading...'} />;
      }
    }

    return (
      <div className={'d-flex justify-content-center align-items-center'}>
        {foo}
      </div>
    );
  }
}
